// @flow @jsx h

import { h } from 'preact'
import style from './index.css'

type Item = {
  type: 'item',
  value: string
}

type Props = {
  value: Item[]
}

function UnorderedList (props: Props) {
  const { value } = props
  return (
    <ul className={style.unorderedList}>
      {value.map((item, idx) => (
        <li
          key={String(idx)}
          dangerouslySetInnerHTML={{ __html: item.value }}
        />
      ))}
    </ul>
  )
}

export default UnorderedList



// WEBPACK FOOTER //
// ./src/lib/@nrk/dh-feature-components/UnorderedList/index.js